<template>
  <div>
    <Card
      :max-height="500"
      :padding="false"
    >
      <template slot="header">
        Camping
      </template>
      <template slot="extras">
        <v-btn
          light
          to="/reserve/camping"
        >
          Add More
        </v-btn>
      </template>
      <v-alert
        :value="true"
        dismissible
        type="warning"
      >
        <span
          v-html="settings.textCamping"
        />
      </v-alert>
      <Camping
        show-party
        show-details
      />
    </Card>
    <Card
      :max-height="500"
      :padding="false"
    >
      <template slot="header">
        Parking
      </template>
      <template slot="extras">
        <v-btn
          light
          to="/reserve/parking"
        >
          Add More
        </v-btn>
      </template>
      <v-alert
        :value="true"
        dismissible
        type="warning"
      >
        <span
          v-html="settings.textParking"
        />
      </v-alert>
      <Parking/>
    </Card>
    <Card
      :max-height="500"
      :padding="false"
    >
      <template slot="header">
        Non-Resident Gate Passes
      </template>
      <template slot="extras">
        <v-btn
          light
          to="/reserve/passes"
        >
          Add More
        </v-btn>
      </template>
      <v-alert
        :value="true"
        dismissible
        type="warning"
      >
        <span
          v-html="settings.textGatePass"
        />
      </v-alert>
      <GatePasses/>
    </Card>
    <Card
      v-if="assertSetting('personReserve', 1)"
      :max-height="500"
      :padding="false"
    >
      <template slot="header">
        Other Charges
      </template>
      <template slot="extras">
        <v-btn
          light
          to="/reserve/other"
        >
          Add More
        </v-btn>
      </template>
      <OtherCharges/>
    </Card>
    <Card>
      <h2 slot="header">Totals</h2>
      <Totals/>
    </Card>
  </div>
</template>

<script>
// import components
import Camping from './Camping'
import GatePasses from './GatePasses'
import Parking from './Parking'
import OtherCharges from './OtherCharges'
import Totals from './Totals'
// Import vuex map
import { mapActions } from 'vuex'

export default {
  name: 'Checkout',
  components: {
    Camping,
    GatePasses,
    Parking,
    OtherCharges,
    Totals
  },
  mounted () {
    this.getCart()
  },
  methods: {
    ...mapActions({
      getCart: 'cart/getCart'
    })
  }
}
</script>
